import { Collapse } from '@mui/material';
import React, { useState } from 'react';
import { ParentSidebarNavItem, SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_TRANSITION_DURATION_MS } from '../../../types';
import SidebarItems from './SidebarItems';

interface SidebarProps {
  userId: string;
  authenticityToken: string;
  navItems: Array<ParentSidebarNavItem>;
  isInitiallyExpanded: boolean;
  persistCollapseState?: boolean;
}

const Sidebar = ({
  userId, authenticityToken, navItems, isInitiallyExpanded, persistCollapseState = true,
}: SidebarProps) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(isInitiallyExpanded);

  const updateIsExpanded = (newIsExpanded: boolean) => {
    setIsExpanded(newIsExpanded);

    const event = new CustomEvent('sidebar-resize', { detail: newIsExpanded, bubbles: true, cancelable: true });
    window.dispatchEvent(event);

    if (!persistCollapseState) return;

    const route = `/users/${userId}/set-is-sidebar-expanded`;
    const bodyParams = {
      authenticity_token: authenticityToken,
      is_sidebar_expanded: newIsExpanded,
    };
    const options = {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json; charset=UTF-8',
      }),
      body: JSON.stringify(bodyParams),
    };
    fetch(route, options);
  };

  const collapse = () => updateIsExpanded(false);
  const expand = () => updateIsExpanded(true);

  return (
    <div className="hidden md:flex">
      <Collapse
        orientation="horizontal"
        in={isExpanded}
        collapsedSize={SIDEBAR_COLLAPSED_WIDTH}
        timeout={SIDEBAR_TRANSITION_DURATION_MS}
        sx={{
          height: '100vh',
          display: { xs: 'none', sm: 'flex' },
          flexShrink: 0,
        }}
      >
        <div className="flex flex-col w-64 h-full bg-slate-800 ">
          <SidebarItems
            navItems={navItems}
            collapse={collapse}
            expand={expand}
            isInitiallyExpanded={isInitiallyExpanded}
          />
        </div>
      </Collapse>
    </div>
  );
};

export default Sidebar;
